import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import authService from '../../services/api/authService';
import { TaskyAlert, TaskyButton, TaskyFormGroup, TaskyInput } from '../tasky';

const ForgotPasswordForm: React.FC = () => {
  // ログイン失敗の案内から来た場合は入力済みのメールアドレスを引き継ぐ（URL には載せない）
  const location = useLocation();
  const initialEmail = (location.state as { email?: unknown } | null)?.email;
  const [email, setEmail] = useState(typeof initialEmail === 'string' ? initialEmail : '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');
    try {
      const response = await authService.forgotPassword({ email });
      setIsSuccess(true);
      setMessage(response.message || 'パスワードリセットリンクが送信されました。メールをご確認ください。');
    } catch (err: any) {
      setIsSuccess(false);
      setMessage(err.response?.data?.message || 'リクエスト処理中にエラーが発生しました。もう一度お試しください。');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="text-center py-4">
        <div className="flex justify-center mb-4">
          <div className="w-14 h-14 rounded-full bg-success/10 flex items-center justify-center">
            <CheckCircle2 className="w-7 h-7 text-success" />
          </div>
        </div>
        <h1 className="text-xl font-semibold text-dark mb-2">メールを送信しました</h1>
        <p className="text-sm text-gray-500 leading-relaxed">{message}</p>
      </div>
    );
  }

  return (
    <>
      <div className="text-center mb-6">
        <h1 className="text-xl font-semibold text-dark mb-2">パスワードをリセット</h1>
        <p className="text-sm text-gray-500 leading-relaxed">
          登録したメールアドレスを入力してください。
        </p>
      </div>

      {message && !isSuccess && (
        <TaskyAlert tone="error" className="mb-4">
          {message}
        </TaskyAlert>
      )}

      <form onSubmit={handleSubmit} noValidate className="space-y-5">
        <TaskyFormGroup label="メールアドレス" required htmlFor="email">
          <TaskyInput
            id="email"
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            autoComplete="email"
            required
          />
        </TaskyFormGroup>

        <TaskyButton type="submit" isLoading={isSubmitting} className="w-full">
          {isSubmitting ? '送信中...' : 'リセットリンクを送信'}
        </TaskyButton>
      </form>
    </>
  );
};

export default ForgotPasswordForm;
